import moment from 'moment';

export const getUploadedTime = dateString => {
	const utcDate = new Date(dateString);
	const myLocalDate = new Date(
		Date.UTC(
			utcDate.getFullYear(),
			utcDate.getMonth(),
			utcDate.getDate(),
			utcDate.getHours(),
			utcDate.getMinutes()
		)
	);

	const today = moment();
	const momentDate = moment(myLocalDate);

	return momentDate.isSame(today, 'day')
		? `${momentDate.format('h:mma')} today`
		: `${momentDate.format('h:mma')} on ${momentDate.format('MMM D YYYY')}`;
};

export const agContainerStyle = { width: '100%', height: '100%' };
export const agGridStyle = { height: '40vh' };
export const agDefaultColumnDefination = {
	flex: 1,
	minWidth: 100,
	resizable: true,
	sortable: true,
	filter: true,
};

export const encryptObjectToString = obj => {
	const objString = JSON.stringify(obj);
	const key = 3;

	let encryptedString = '';
	for (let i = 0; i < objString.length; i++) {
		let charCode = objString.charCodeAt(i);

		if (charCode >= 65 && charCode <= 90) {
			charCode = ((charCode - 65 + key) % 26) + 65;
		} else if (charCode >= 97 && charCode <= 122) {
			charCode = ((charCode - 97 + key) % 26) + 97;
		}

		encryptedString += String.fromCharCode(charCode);
	}

	return encryptedString;
};
